import type { JSX } from "react";

import { AlertDialog as BaseAlertDialog } from "@base-ui/react/alert-dialog";
import { Button } from "@frontend/components/atoms/Button";

import type { AlertDialogActionProps } from "./AlertDialog.types";

export function AlertDialogAction({
  children,
  variant = "primary",
  ...props
}: AlertDialogActionProps): JSX.Element {
  return (
    <BaseAlertDialog.Close
      data-slot="alert-dialog-action"
      render={<Button variant={variant} size="md" />}
      {...props}
    >
      {children}
    </BaseAlertDialog.Close>
  );
}
